<template>
  <section>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">レポート更新</p>
      </header>

      <section class="modal-card-body main">
        <form @submit.prevent="submit">
          <b-field
            label="レポート名"
            :type="{'is-danger': errors.has('name')}"
            :message="errors.first('name')">
            <b-input
              name="name"
              data-vv-as="レポート名"
              v-model="name"
              maxlength="64"
              size="is-medium"
              v-validate="'required'"/>
          </b-field>
          
          <b-field label="トークン">
              <b-input :value="apiToken" disabled></b-input>
          </b-field>
          
          <b-field>
            <b-checkbox v-model="tokenRecreate">トークンを再作成する</b-checkbox>
          </b-field>
        </form>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-danger left-position" @click="deleteReport">レポートを削除</button>
        <button class="button" type="button" @click="$parent.close()">キャンセル</button>
        <button class="button is-primary" @click="submit">更新</button>
      </footer>
    </div>
  </section>
</template>

<script>
import snackbar from "@/shared/snackbar";

export default {
  data() {
    return {
      name: this.$props.reportName,
      tokenRecreate: false,
    };
  },
  props: {
    reportId: {
      type: String,
      default: "",
    },
    reportName: {
      type: String,
      default: "",
    },
    apiToken: {
      type: String,
      default: "",
    },
  },
  methods: {
    submit() {
      this.$validator.validateAll().then( async (result) => {
        try {
          if (result) {
            const self = this;
            const params = {
              report_id: this.reportId,
              report_name: this.name,
              token: this.apiToken,
              tokenRecreate: this.tokenRecreate,
            };
            const response = await this.$store.dispatch("report/updateReport", params);
            self.$parent.close();
            snackbar.success(this, { message: "レポートを更新しました。"});
          }
        } catch (error) {
          snackbar.error(this, { message: `レポートの作成に失敗しました。: ${error}` });
        }
      });
    },
    deleteReport() {
      const currentReportInfo = this.$store.getters["report/currentReportInfo"];

      this.$dialog.confirm({
        title: "レポート削除",
        message: "本当に削除しますか？この操作は取り消せません。このレポート内のテンプレートはすべて削除されます。",
        confirmText: "レポートを削除する",
        cancelText: "キャンセル",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$store.dispatch("report/deleteReport", this.reportId).then(() => {
            this.$parent.close();
            // if a deleted report is the displaying one, will back to dashboard.
            if (currentReportInfo.report_id === this.reportId) {
              this.$router.push("/dashboard");
            }
            snackbar.success(this, { message: "レポートを削除しました。"});
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-card-foot {
  display: flex;
  justify-content: flex-end;

  & .left-position {
    position: absolute;
    left: 16px;
  }
}
.main {
  display: flex;
  flex-direction: column;

  @media screen and (min-width:1024px) {
    min-width: 680px;
  }
}
</style>
